export default __webpack_public_path__ + "static/media/available.2d626677.svg";